"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _devLogger = _interopRequireDefault(require("react-utils/devLogger"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _iconAliases = _interopRequireDefault(require("icons/iconAliases"));

var _classnames = _interopRequireDefault(require("classnames"));

var _memoize = _interopRequireDefault(require("react-utils/memoize"));

var _IconConstants = require("./IconConstants");

var _iconName = require("../utils/propTypes/iconName");

var _memoizeOne = _interopRequireDefault(require("react-utils/memoizeOne"));

var _Timers = require("../utils/Timers");

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  font: inherit !important;\n  &::before {\n    content: \"", "\";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var sizeToRes = function sizeToRes(size) {
  return size <= _IconConstants.ICON_SIZES.small ? 'low' : 'high';
};

var getIconClassName = function getIconClassName(size, measuredRes) {
  var res = size != null ? sizeToRes(_IconConstants.ICON_SIZES[size] || size) : measuredRes;
  return "private-icon__" + res;
};

var getComputedFontSize = function getComputedFontSize(size) {
  if (!size) return null;

  if (_IconConstants.ICON_SIZES.hasOwnProperty(size)) {
    return _IconConstants.ICON_SIZES[size];
  }

  return size;
};

var getStyle = function getStyle(style, color, size) {
  return (0, _extends2.default)({
    color: color
  }, style, {
    fontSize: getComputedFontSize(size)
  });
};

var IconContent = _styledComponents.default.span.withConfig({
  displayName: "UIIcon__IconContent",
  componentId: "ca7bwe-0"
})(_templateObject(), function (_ref) {
  var ligature = _ref.ligature;
  return ligature;
});

var getIconContent = (0, _memoize.default)(function (ligature) {
  return _react.default.createElement(IconContent, {
    "aria-hidden": true,
    ligature: ligature
  });
});
var hasPingedNewRelic = false;

var UIIcon =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(UIIcon, _PureComponent);

  function UIIcon(props) {
    var _this;

    (0, _classCallCheck2.default)(this, UIIcon);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(UIIcon).call(this, props));

    _this.measureSize = function () {
      if (!_this._el || _this.props.size) return;
      var styles = window.getComputedStyle(_this._el, null);

      if (styles == null) {
        // See #4208
        return;
      }

      var measuredSize = parseInt(styles.fontSize, 10);
      var measuredRes = sizeToRes(measuredSize);

      if (measuredRes !== _this.state.measuredRes) {
        _this.setState({
          measuredRes: measuredRes
        });
      }
    };

    _this.refCallback = function (ref) {
      _this._el = ref;
    };

    _this.state = {
      // Perf: Most icons are low-res, so this default minimizes state changes from measureSize()
      measuredRes: 'low'
    };
    _this._getStyle = (0, _memoizeOne.default)(getStyle);
    return _this;
  }

  (0, _createClass2.default)(UIIcon, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.delayedMeasureSize();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      // ⚠️ This condition prevents infinite loops! ⚠️
      if (prevState.measuredRes === this.state.measuredRes) {
        this.delayedMeasureSize();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      (0, _Timers.cancelSchedulerCallback)(this._timeout);
    }
  }, {
    key: "delayedMeasureSize",
    value: function delayedMeasureSize() {
      (0, _Timers.cancelSchedulerCallback)(this._timeout); // Ensure only one callback is queued at a time

      this._timeout = (0, _Timers.requestSchedulerCallback)(this.measureSize);
    }
    /**
     * Measure the `fontSize` in the DOM to determine whether this should be a high-res or low-res
     * icon. Note that the measurement is skipped when the `size` prop is set.
     */

  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          color = _this$props.color,
          className = _this$props.className,
          name = _this$props.name,
          screenReaderText = _this$props.screenReaderText,
          style = _this$props.style,
          size = _this$props.size,
          rest = (0, _objectWithoutProperties2.default)(_this$props, ["color", "className", "name", "screenReaderText", "style", "size"]);
      var measuredRes = this.state.measuredRes;

      if (_iconAliases.default[name]) {
        if (window.newrelic && !hasPingedNewRelic) {
          hasPingedNewRelic = true;
          window.newrelic.addPageAction('icon-alias', {
            alias: name
          });
        }

        _devLogger.default.warn({
          message: "UIIcon: \"" + name + "\" is a deprecated alias. Please use the canonical icon name.",
          key: "UIIcon-" + name,
          url: 'https://tools.hubteamqa.com/ui-library/styles/icons'
        });
      }

      var computedName = _iconAliases.default[name] || name;
      var computedClassName = (0, _classnames.default)('private-icon', getIconClassName(size, measuredRes), className);
      return _react.default.createElement("span", (0, _extends2.default)({}, rest, {
        className: computedClassName,
        "data-icon-name": computedName,
        ref: this.refCallback,
        style: this._getStyle(style, color, size)
      }), getIconContent(computedName), screenReaderText ? // Spaces around screenReaderText prevents collisions withsiblingtext.
      _react.default.createElement("span", {
        className: "sr-only"
      }, " ", screenReaderText, " ") : undefined);
    }
  }]);
  return UIIcon;
}(_react.PureComponent);

exports.default = UIIcon;
UIIcon.propTypes = {
  color: _propTypes.default.string,
  name: (0, _iconName.getIconNamePropType)().isRequired,
  screenReaderText: _propTypes.default.string,
  size: _propTypes.default.oneOfType([_propTypes.default.oneOf(Object.keys(_IconConstants.ICON_SIZES)), _propTypes.default.number])
};
UIIcon.displayName = 'UIIcon';
module.exports = exports.default;